module.exports = __webpack_public_path__ + "static/assets/ce290036f6f44c44c63b7096140d50e9.svg";